import apiClient from "services/axios";

const API = {
  list: "/api/v1/widget-states",
  create: "/api/v1/widget-states",
  detail: "/api/v1/widget-states",
  update: "/api/v1/widget-states",
  delete: "/api/v1/widget-states",
};

export const list = async (filter) => {
  const response = await apiClient.get(API.list, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};

export const create = async (body) => {
  let payload = body;
  if (body.imageFile) {
    payload = new FormData();
    payload.append("name", body.name);
    payload.append("imageFile", body.imageFile);
    payload.append("widgetId", body.widgetId);
    payload.append("valueConditionExp", body.valueConditionExp);
  }

  const response = await apiClient.post(API.create, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (response) {
    return response.data;
  }
  return false;
};

export const detail = async (id) => {
  const response = await apiClient.get(`${API.detail}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};

export const update = async (id, body) => {
  let payload = body;
  if (body.bgImageFile) {
    payload = new FormData();
    payload.append("name", body.name);
    payload.append("imageFile", body.imageFile);
    payload.append("valueConditionExp", body.valueConditionExp);
  }
  const response = await apiClient.patch(`${API.update}/${id}`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (response) {
    return response.data;
  }
  return false;
};

export const remove = async (id) => {
  const response = await apiClient.delete(`${API.delete}/${id}`);
  if (response) {
    return response.data;
  }
  return false;
};
